import { render, staticRenderFns } from "./LanguageAbility.vue?vue&type=template&id=6f4aaec3&scoped=true&"
import script from "./LanguageAbility.vue?vue&type=script&lang=js&"
export * from "./LanguageAbility.vue?vue&type=script&lang=js&"
import style0 from "./LanguageAbility.vue?vue&type=style&index=0&id=6f4aaec3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4aaec3",
  null
  
)

export default component.exports